import { Directive, Input } from '@angular/core';
import { LayoutElementDirective } from './layout-element.directive';

@Directive({
  selector: '[am-layout-footer]',
})
export class LayoutFooterDirective extends LayoutElementDirective {
  @Input() height = '75px';
}
